/**
 * hzo-pdp.js — de eigen onderdelen van de productpagina.
 *
 * Bevat: de pijltjes bij de fotostrook, het kortingslabel bij de prijs, het
 * maatvenster, de prijs op de koopknop en de altijd-open uitklapper.
 *
 * DE MEESCHUIVENDE KOOPBALK STAAT HIER NIET MEER IN. Op verzoek teruggezet naar
 * wat het thema zelf doet: geen eigen kiezers op de balk, en geen eigen trigger
 * om hem te tonen. Horizon bepaalt nu zelf of en wanneer die balk verschijnt.
 *
 * Alles is defensief: ontbreekt een element, dan gebeurt er niets.
 */
(() => {
  'use strict';

  /* ─────────────── de voorraadregel ───────────────
   * de voorraadregel uit het andere thema. Het blok dat hem toonde is van dit
   * thema verwijderd; deze functie vindt dus niets meer en doet niets.
   *
   * Het getal komt NIET uit de voorraad maar uit de plek van de variant in de
   * rij; dat rekenwerk staat in `blocks/hzo-stock-urgency.liquid`. Hier gebeurt
   * alleen het omzetten bij een andere maat, uit de tabel in het data-attribuut.
   *
   * Geen eigen luisteraar op `change`: `kijkMee` roept `draai()` al een paar keer
   * aan na een variantwissel, en deze functie leest gewoon uit wat er dan staat.
   * Twee luisteraars die hetzelfde doen lopen vroeg of laat uit de pas.
   */
  /* De variant die de bezoeker NET heeft aangeklikt. Horizon schrijft het
   * verborgen veld `name="id"` pas als zijn hertekening over het netwerk terug
   * is; tot dat moment staat daar nog de vorige variant in. Deze variabele
   * overbrugt precies dat gat. Hij wordt gewist zodra het veld bijgetrokken is,
   * zodat de server daarna weer de baas is. */
  let vroegeVariant = null;

  function voorraadRegelen() {
    document.querySelectorAll('[data-hzo-voorraad]').forEach((blok) => {
      const veld = document.querySelector('.product-details variant-picker input[name="id"], .product-details [name="id"]');
      const uitVeld = veld ? veld.value : null;
      if (uitVeld && vroegeVariant && String(uitVeld) === String(vroegeVariant)) vroegeVariant = null;
      const gekozen = vroegeVariant || uitVeld;
      if (!gekozen) return;

      let kaart = {};
      try {
        kaart = JSON.parse(blok.dataset.hzoVoorraadkaart || '{}');
      } catch (e) {
        return; // liever niets tonen dan een verkeerd getal
      }

      const regel = kaart[String(gekozen)];
      if (!regel) return;

      const [aantal, leverbaar] = regel;

      // het andere thema verbergt alleen bij een uitverkocht product; hier ook bij een
      // uitverkochte maat, anders staat er een aantal bij iets wat niet te koop is
      const verbergen = leverbaar !== 1;
      if (blok.hidden !== verbergen) blok.hidden = verbergen;
      if (verbergen) return;

      const getal = blok.querySelector('[data-hzo-voorraad-getal]');
      if (getal && getal.textContent !== String(aantal)) getal.textContent = String(aantal);
    });
  }


  /* ─────────────── de meeschuivende koopbalk ───────────────
   * Ontwerp B uit de wireframe: twee knopjes op de balk, elk opent zijn eigen rij
   * in een paneel boven de balk. De balk zelf blijft 75px.
   *
   * ER KOMT GEEN TWEEDE KIEZER. De knopjes klikken de ECHTE radioknop aan in de
   * `<variant-picker>` op de pagina. Daarna doet Horizon de rest: foto, prijs,
   * voorraad en de balk zelf opnieuw tekenen. Zouden we hier een eigen
   * administratie bijhouden, dan lopen die twee vroeg of laat uiteen.
   *
   * En dus ook: GEEN MutationObserver op de balk. Horizon vervangt de balk bij een
   * variantwissel, en onze knopjes zijn dan weg — maar die zetten we terug via het
   * `change`-signaal in `kijkMee`, niet via een waarnemer op het element waar we
   * zelf in schrijven. Dat laatste legde vanmiddag het hele tabblad plat.
   */

  function chatIsEchtZichtbaar() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    if (!chat.offsetParent && chat.getBoundingClientRect().width === 0) return false;
    return true;
  }

  function echteKiezer(productId) {
    return (
      document.querySelector(`variant-picker[data-product-id="${productId}"]`) ||
      document.querySelector('.product-details variant-picker') ||
      document.querySelector('variant-picker')
    );
  }

  /** Leest de opties uit de echte kiezer. Elke waarde houdt een verwijzing naar
   *  zijn eigen radioknop, want dat is wat we straks indrukken. */
  function optiesLezen(kiezer) {
    if (!kiezer) return [];
    const perNaam = new Map();
    kiezer.querySelectorAll('input[type="radio"][data-option-name]').forEach((invoer) => {
      const naam = invoer.dataset.optionName;
      if (!naam) return;
      if (!perNaam.has(naam)) perNaam.set(naam, { naam, waarden: [] });
      const label = invoer.closest('label');
      const klas = (label && label.className) || '';
      perNaam.get(naam).waarden.push({
        tekst: invoer.value,
        invoer,
        gekozen: invoer.checked,
        uit: invoer.disabled || /unavailable|sold|-op\b/i.test(klas),
        staal: label && label.querySelector('.hzo-staalvlak, [class*="swatch"]'),
      });
    });
    return [...perNaam.values()].filter((o) => o.waarden.length > 1);
  }

  function paneelSluiten(bar) {
    const paneel = bar.querySelector('.hzo-balk__paneel');
    if (paneel) paneel.hidden = true;
    bar.querySelectorAll('.hzo-balk__groep').forEach((g) => (g.hidden = true));
    bar.querySelectorAll('.hzo-balk__knopje').forEach((k) => k.setAttribute('aria-expanded', 'false'));
  }

  function groepTonen(bar, naam) {
    const paneel = bar.querySelector('.hzo-balk__paneel');
    if (!paneel) return;
    const groep = paneel.querySelector(`.hzo-balk__groep[data-hzo-optie="${CSS.escape(naam)}"]`);
    if (!groep) return;
    const alOpen = !groep.hidden && !paneel.hidden;
    paneelSluiten(bar);
    if (alOpen) return;
    paneel.hidden = false;
    groep.hidden = false;
    const knopje = bar.querySelector(`.hzo-balk__knopje[data-hzo-optie="${CSS.escape(naam)}"]`);
    if (knopje) knopje.setAttribute('aria-expanded', 'true');
    // bij negentien maten past de rij niet: zet de gekozen waarde in beeld
    const gekozen = groep.querySelector('.hzo-balk__waarde.is-aan, .hzo-balk__staal.is-aan');
    if (gekozen && gekozen.scrollIntoView) {
      gekozen.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }

  /* Onthoudt welke knopjesrij wij zelf gemaakt hebben.
   *
   * Horizon tekent de balk na een variantwissel opnieuw en neemt daarbij de opmaak
   * van onze knopjes mee — maar niet de klikafhandeling, want die zit op het
   * element en niet in de HTML. Je houdt dan knopjes over die er goed uitzien en
   * niets doen. Een controle op "staat er al een rij?" trapt daar in: die rij
   * stáát er, hij is alleen dood.
   *
   * Vandaar deze lijst: staat de gevonden rij er niet in, dan is het een kopie en
   * bouwen we hem opnieuw. Gemeten op 11 aug 2026: het knopje opende het paneel
   * niet meer nadat Horizon één keer opnieuw had getekend. */
  const eigenRijen = new WeakSet();
  const eigenParen = new WeakSet();

  /* Om dezelfde reden als hierboven, voor drie plekken die het eerder met een
     `dataset`-vlag deden. Horizon kopieert bij het hertekenen wél het attribuut
     maar niet de luisteraars en waarnemers eronder: de vlag zei dan "geregeld"
     terwijl er niets meer luisterde. Een WeakSet kán niet meegekopieerd worden,
     want hij verwijst naar het element zelf en niet naar een stukje HTML. */
  const eigenTriggers = new WeakSet();
  const eigenPaarBakken = new WeakSet();
  const eigenStrookBakken = new WeakSet();

  function balkVerbouwen(balkElement) {
    const bar = balkElement.querySelector('[ref="stickyBar"]');
    if (!bar) return;

    const bestaand = bar.querySelector('.hzo-balk__kiezers');
    if (bestaand) {
      if (eigenRijen.has(bestaand)) return; // van ons, luisteraars zitten er nog op
      bestaand.remove();
      const oudPaneel = bar.querySelector('.hzo-balk__paneel');
      if (oudPaneel) oudPaneel.remove();
    }

    const opties = optiesLezen(echteKiezer(balkElement.dataset.productId));
    if (!opties.length) return;

    const info = bar.querySelector('.sticky-add-to-cart__info');
    if (!info) return;

    // de regel "Light Blue / M" wordt vervangen door de knopjes
    const variantregel = bar.querySelector('.sticky-add-to-cart__variant');
    if (variantregel) variantregel.hidden = true;

    const houder = document.createElement('div');
    houder.className = 'hzo-balk__kiezers';

    const paneel = document.createElement('div');
    paneel.className = 'hzo-balk__paneel';
    paneel.hidden = true;

    opties.forEach((optie) => {
      const gekozen = optie.waarden.find((w) => w.gekozen);

      /* het knopje op de balk */
      const knopje = document.createElement('button');
      knopje.type = 'button';
      knopje.className = 'hzo-balk__knopje';
      knopje.dataset.hzoOptie = optie.naam;
      knopje.setAttribute('aria-expanded', 'false');
      if (!gekozen) knopje.classList.add('is-leeg');

      if (gekozen && gekozen.staal) {
        const vlak = document.createElement('span');
        vlak.className = 'hzo-balk__vlak';
        const stijl = getComputedStyle(gekozen.staal);
        if (stijl.backgroundImage && stijl.backgroundImage !== 'none') {
          vlak.style.backgroundImage = stijl.backgroundImage;
          vlak.style.backgroundSize = 'cover';
          vlak.style.backgroundPosition = 'center';
        } else {
          vlak.style.background = stijl.backgroundColor;
        }
        knopje.appendChild(vlak);
      }

      const waarde = document.createElement('span');
      waarde.className = 'hzo-balk__knopjetekst';
      waarde.textContent = gekozen ? gekozen.tekst : `Choose a ${optie.naam.toLowerCase()}`;
      knopje.appendChild(waarde);

      const pijl = document.createElement('span');
      pijl.className = 'hzo-balk__pijl';
      pijl.setAttribute('aria-hidden', 'true');
      pijl.textContent = '▾';
      knopje.appendChild(pijl);

      houder.appendChild(knopje);

      /* de rij in het paneel */
      const groep = document.createElement('div');
      groep.className = 'hzo-balk__groep';
      groep.dataset.hzoOptie = optie.naam;
      groep.hidden = true;

      const kop = document.createElement('p');
      kop.className = 'hzo-balk__groepkop';
      kop.textContent = optie.naam;
      if (gekozen) {
        const b = document.createElement('b');
        b.textContent = gekozen.tekst;
        kop.appendChild(b);
      }
      groep.appendChild(kop);

      const isStalenrij = optie.waarden.some((w) => w.staal);
      const rij = document.createElement('div');
      rij.className = 'hzo-balk__rij ' + (isStalenrij ? 'hzo-balk__rij--stalen' : 'hzo-balk__rij--maten');

      optie.waarden.forEach((w) => {
        const k = document.createElement('button');
        k.type = 'button';
        if (isStalenrij && w.staal) {
          k.className = 'hzo-balk__staal' + (w.gekozen ? ' is-aan' : '') + (w.uit ? ' is-uit' : '');
          const stijl = getComputedStyle(w.staal);
          if (stijl.backgroundImage && stijl.backgroundImage !== 'none') {
            k.style.backgroundImage = stijl.backgroundImage;
            k.style.backgroundSize = 'cover';
            k.style.backgroundPosition = 'center';
          } else {
            k.style.background = stijl.backgroundColor;
          }
          k.setAttribute('aria-label', w.tekst);
        } else {
          k.className = 'hzo-balk__waarde' + (w.gekozen ? ' is-aan' : '') + (w.uit ? ' is-uit' : '');
          k.textContent = w.tekst;
        }
        k.setAttribute('aria-pressed', w.gekozen ? 'true' : 'false');
        k.dataset.hzoOptie = optie.naam;
        k.dataset.hzoWaarde = w.tekst;
        rij.appendChild(k);
      });

      groep.appendChild(rij);
      paneel.appendChild(groep);
    });

    /* De prijs blijft staan waar Horizon hem zet: een eigen kolom, pal links van
     * de knop. Dat is waar het oog heen gaat vlak voor je klikt. Alleen de vorm
     * verandert (twee regels, rechts uitgelijnd) en die zit in de CSS.
     *
     * Eerder stond hij hier in dezelfde regel als de knopjes. Dat scheelde een
     * kolom, maar het duwde het bedrag weg bij de knop. */
    /* Valt er maar één ding te kiezen, dan mag dat vakje de vrije ruimte vullen.
     * Bij de 13 producten met één kleur bleef er anders een knopje van 40px over
     * in een kolom van 375. Het tellen kan alleen hier, want `opties` bevat al
     * geen opties met één waarde. */
    if (opties.length === 1) houder.classList.add('hzo-balk__kiezers--een');

    eigenRijen.add(houder);
    info.appendChild(houder);
    bar.appendChild(paneel);

    /* de koopknop: alleen een icoon, en hij wacht tot alles gekozen is */
    const knop = bar.querySelector('.sticky-add-to-cart__button');
    if (knop) {
      if (!knop.getAttribute('aria-label')) {
        const tekst = knop.textContent.replace(/\s+/g, ' ').trim();
        if (tekst) knop.setAttribute('aria-label', tekst);
      }
      const ontbreekt = opties.find((o) => !o.waarden.some((w) => w.gekozen));
      if (ontbreekt) {
        knop.classList.add('hzo-balk__knop--wacht');
        knop.dataset.hzoOntbreekt = ontbreekt.naam;
      } else {
        delete knop.dataset.hzoOntbreekt;
        knop.classList.remove('hzo-balk__knop--wacht');
      }
    }

    bar.classList.add('hzo-balk');
  }

  /* ÉÉN luisteraar op het document, niet op elk knopje.
   *
   * Reden: Horizon tekent de balk na een variantwissel opnieuw en kopieert daarbij
   * onze markup mee. Een luisteraar zit op het élement en niet in de HTML, dus die
   * gaat bij zo'n kopie verloren: je houdt knopjes over die er goed uitzien en
   * niets doen. Gemeten op 11 aug 2026 — ook al bij het laden, want Horizon tekent
   * de balk daar ook een keer opnieuw.
   *
   * Op het document overleeft de afhandeling elke kopie. Wat het knopje moet weten
   * staat daarom in de HTML zelf (`data-hzo-optie`, `data-hzo-waarde`) in plaats
   * van in een afsluiting. */
  document.addEventListener('click', (e) => {
    const doel = e.target instanceof Element ? e.target : null;
    if (!doel) return;

    const waarde = doel.closest('.hzo-balk__waarde, .hzo-balk__staal');
    if (waarde) {
      const bar = waarde.closest('.hzo-balk');
      if (bar) paneelSluiten(bar);
      const balkElement = waarde.closest('sticky-add-to-cart');
      const kiezer = echteKiezer(balkElement && balkElement.dataset.productId);
      if (kiezer) {
        const invoer = kiezer.querySelector(
          `input[type="radio"][data-option-name="${CSS.escape(waarde.dataset.hzoOptie || '')}"]` +
            `[value="${CSS.escape(waarde.dataset.hzoWaarde || '')}"]`
        );
        if (invoer) invoer.click(); // de ECHTE radioknop; Horizon doet de rest
      }
      return;
    }

    const knopje = doel.closest('.hzo-balk__knopje');
    if (knopje) {
      const bar = knopje.closest('.hzo-balk');
      if (bar) groepTonen(bar, knopje.dataset.hzoOptie || '');
      return;
    }

    document.querySelectorAll('.hzo-balk').forEach((bar) => {
      if (!bar.contains(doel)) paneelSluiten(bar);
    });
  });

  /* De koopknop wacht zolang er nog iets te kiezen valt. Dit moet in de VANGFASE,
   * anders is Horizons eigen klikafhandeling al langs geweest en ligt het product
   * in de winkelwagen voordat wij er iets van zeggen. */
  document.addEventListener(
    'click',
    (e) => {
      const doel = e.target instanceof Element ? e.target : null;
      const knop = doel && doel.closest('.hzo-balk .sticky-add-to-cart__button');
      if (!knop || !knop.dataset.hzoOntbreekt) return;
      e.preventDefault();
      e.stopPropagation();
      const bar = knop.closest('.hzo-balk');
      if (bar) groepTonen(bar, knop.dataset.hzoOntbreekt);
    },
    true
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('.hzo-balk').forEach(paneelSluiten);
  });

  /* ─────────────── de balk laten verschijnen ───────────────
   * Horizon zet de balk NOOIT aan zodra er een <shopify-chat> op de pagina staat,
   * om te voorkomen dat de balk en de chatbel elkaar overlappen. Op deze winkel
   * staat die chat er wel, maar leeg: 0 bij 0, niets in beeld. Zonder dit stukje
   * blijft de balk dus altijd onzichtbaar.
   *
   * Dit is GEEN kopie van Horizons logica: het enige wat hier gebeurt is
   * `data-stuck` omzetten. Het tonen, de animatie en de vormgeving doet Horizons
   * eigen CSS. En het draait alleen zolang die chat écht onzichtbaar is — zet je
   * de chat aan, dan doet dit niets meer en is Horizons gedrag terug.
   */
  function balkZelfTonen(balkElement) {
    const bar = balkElement.querySelector('[ref="stickyBar"]');
    if (!bar || eigenTriggers.has(bar)) return;

    const chat = document.querySelector('shopify-chat');
    if (!chat || chatIsEchtZichtbaar()) return; // Horizon regelt het zelf

    const koopblok = document.querySelector('.buy-buttons-block');
    const voet = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (!koopblok || !voet) return;

    eigenTriggers.add(bar);

    let voetInBeeld = false;

    const zet = () => {
      const r = koopblok.getBoundingClientRect();
      const voorbij = r.bottom < 0;
      const stand = voorbij && !voetInBeeld ? 'true' : 'false';
      if (bar.dataset.stuck !== stand) bar.dataset.stuck = stand;
    };

    new IntersectionObserver(zet).observe(koopblok);
    new IntersectionObserver(
      (entries) => {
        const [e] = entries;
        if (e) voetInBeeld = e.isIntersecting;
        zet();
      },
      { rootMargin: '200px 0px 0px 0px' }
    ).observe(voet);

    zet();
  }


  /* ─────────────── pijltjes bij de fotostrook ───────────────
   * De strook schuift, maar dat zie je pas als je het probeert. Vandaar twee
   * pijltjes — met één regel: ze bestaan alleen als er echt iets te schuiven is.
   *
   *   past alles in beeld        geen pijltjes
   *   helemaal links             alleen rechts
   *   ergens in het midden       allebei
   *   helemaal rechts            alleen links
   *
   * Er wordt niets verborgen met opacity: een pijltje dat er niet toe doet is
   * ook echt weg uit de pagina, dus je kunt er niet per ongeluk op tikken en een
   * schermlezer noemt hem niet.
   *
   * De stand wordt opnieuw bepaald bij schuiven, bij het wisselen van variant
   * (dan verandert het aantal foto's) en bij het draaien van het scherm.
   */

  const SPEELRUIMTE = 3; // px, anders knippert het pijltje op de laatste pixel

  /** Het knoppenpaar naast het kopje, voor de rijen in het keuzepaneel. */
  function paarRegelen(bak) {
    const groep = bak.closest('.hzo-balk__groep');
    const kop = groep && groep.querySelector('.hzo-balk__groepkop');
    if (!kop) return;

    let houder = kop.querySelector(':scope > .hzo-balk__paar');
    if (!houder || !eigenParen.has(houder)) {
      if (houder) houder.remove();
      houder = document.createElement('span');
      houder.className = 'hzo-balk__paar';
      const maak = (kant, teken, label) => {
        const k = document.createElement('button');
        k.type = 'button';
        k.className = 'hzo-balk__paarknop hzo-balk__paarknop--' + kant;
        k.setAttribute('aria-label', label);
        k.textContent = teken;
        k.addEventListener('click', (e) => {
          e.stopPropagation();
          if (k.classList.contains('is-uit')) return;
          const stap = Math.max(bak.clientWidth * 0.8, 90);
          bak.scrollBy({
            left: kant === 'links' ? -stap : stap,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
        return k;
      };
      houder.appendChild(maak('links', '\u2039', 'Terug'));
      houder.appendChild(maak('rechts', '\u203a', 'Verder'));
      kop.appendChild(houder);
      eigenParen.add(houder);
    }

    const vorige = houder.querySelector('.hzo-balk__paarknop--links');
    const volgende = houder.querySelector('.hzo-balk__paarknop--rechts');

    const bepaal = () => {
      const teVeel = Math.round(bak.scrollWidth - bak.clientWidth);
      const nu = Math.round(bak.scrollLeft);
      const kanSchuiven = teVeel > SPEELRUIMTE;
      // Past alles, dan staat er geen knop. Past het niet, dan staan ze er allebei
      // en is de kant waar je niet heen kunt grijs — zo blijft de plek gelijk en
      // springt het kopje niet heen en weer.
      if (houder.hidden === kanSchuiven) houder.hidden = !kanSchuiven;
      vorige.classList.toggle('is-uit', !(kanSchuiven && nu > SPEELRUIMTE));
      volgende.classList.toggle('is-uit', !(kanSchuiven && teVeel - nu > SPEELRUIMTE));
      const vlag = kanSchuiven ? 'true' : 'false';
      if (bak.dataset.hzoSchuifbaar !== vlag) bak.dataset.hzoSchuifbaar = vlag;
    };

    if (!eigenPaarBakken.has(bak)) {
      eigenPaarBakken.add(bak);
      bak.addEventListener('scroll', () => window.requestAnimationFrame(bepaal), { passive: true });
      window.addEventListener('resize', bepaal, { passive: true });
      new ResizeObserver(bepaal).observe(bak);
    }

    bepaal();
  }

  function strookRegelen(bak, wikkel, paar) {
    if (!bak) return;
    if (!bak.parentElement) return;

    /* TWEE VORMEN.
     *
     * Bij de fotostrook hangen de pijltjes half over de strook heen: daar is de
     * achtergrond niet wit en vallen ze op. In het keuzepaneel van de koopbalk is
     * de achtergrond wél wit, en dan is een wit rondje zonder rand onzichtbaar —
     * precies wat de eigenaar zag. Daar komt daarom een paar vierkante knopjes
     * naast het kopje van de rij: altijd op dezelfde plek, nooit over de maten
     * heen, en de kant waar je niet heen kunt wordt grijs in plaats van weg. */
    if (paar) return paarRegelen(bak);

    /* De pijltjes worden in de OUDER gezet en hangen half buiten de strook. Bij de
     * miniaturen is die ouder precies de strook; bij de matenrij is het het hele
     * formulier van de variantkiezer, met de kleurenrij erbij. De pijltjes zouden
     * dan halverwege de kiezer zweven in plaats van naast de maten — en door de
     * `overflow: clip` van dat omhulsel vielen ze helemaal weg. Dat is wat de
     * eigenaar zag: een afgekapte 9.5 en geen pijltjes.
     *
     * Daarom krijgt zo'n strook een eigen omhulsel. Een `<div>` om de `<fieldset>`
     * heen kan: niets in het thema selecteert een direct kind van dat formulier, en
     * Horizon verzamelt zijn `ref="fieldsets[]"` over alle nakomelingen. */
    if (wikkel && !bak.parentElement.classList.contains('hzo-strook__omhulsel')) {
      const nieuwOmhulsel = document.createElement('div');
      nieuwOmhulsel.className = 'hzo-strook__omhulsel';
      bak.replaceWith(nieuwOmhulsel);
      nieuwOmhulsel.appendChild(bak);
    }

    const ouder = bak.parentElement;
    if (!ouder) return;

    /* De pijltjes worden in de OUDER gezet, niet in de strook zelf: ze hangen half
     * buiten de strook. Ze moeten daar dus ook gezocht worden. Stond hier eerst
     * `bak.querySelector`, en dat vond ze nooit — dus kwamen er bij elke ronde twee
     * bij. Bij een variantwissel loopt deze functie vier keer, en na een paar
     * wissels liep de pagina vast. */
    let vorige = ouder.querySelector(':scope > .hzo-strook__pijl--links');
    let volgende = ouder.querySelector(':scope > .hzo-strook__pijl--rechts');

    if (!vorige || !volgende) {
      if (vorige) vorige.remove();
      if (volgende) volgende.remove();
      const maak = (kant, teken, label) => {
        const k = document.createElement('button');
        k.type = 'button';
        k.className = `hzo-strook__pijl hzo-strook__pijl--${kant}`;
        k.setAttribute('aria-label', label);
        k.innerHTML = `<span aria-hidden="true">${teken}</span>`;
        k.addEventListener('click', () => {
          const stap = Math.max(bak.clientWidth * 0.8, 120);
          bak.scrollBy({
            left: kant === 'links' ? -stap : stap,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
        return k;
      };
      vorige = maak('links', '\u2039', 'Vorige foto\u2019s');
      volgende = maak('rechts', '\u203a', 'Volgende foto\u2019s');
      // Het rondje hangt half buiten de strook. Dat moet ergens afgeknipt worden,
      // anders krijgt de pagina er een schuifbalk bij. `overflow: clip` doet dat
      // zonder zelf een schuifbak te worden, dus het schuiven binnenin blijft heel.
      ouder.classList.add('hzo-strook__omhulsel');
      if (getComputedStyle(ouder).position === 'static') ouder.style.position = 'relative';
      ouder.appendChild(vorige);
      ouder.appendChild(volgende);
    }

    const bepaal = () => {
      // afronden: scrollLeft is vaak een gebroken getal terwijl de breedtes hele
      // pixels zijn, en dan lijkt het eind net niet bereikt
      const teVeel = Math.round(bak.scrollWidth - bak.clientWidth);
      const nu = Math.round(bak.scrollLeft);
      const kanSchuiven = teVeel > SPEELRUIMTE;
      const naarLinks = kanSchuiven && nu > SPEELRUIMTE;
      const naarRechts = kanSchuiven && teVeel - nu > SPEELRUIMTE;
      // alleen schrijven als het echt verandert: anders wekt de ResizeObserver
      // zichzelf, want een pijltje dat verschijnt verandert de indeling weer
      if (vorige.hidden === naarLinks) vorige.hidden = !naarLinks;
      if (volgende.hidden === naarRechts) volgende.hidden = !naarRechts;
      const vlag = kanSchuiven ? 'true' : 'false';
      if (bak.dataset.hzoSchuifbaar !== vlag) bak.dataset.hzoSchuifbaar = vlag;
    };

    if (!eigenStrookBakken.has(bak)) {
      eigenStrookBakken.add(bak);
      bak.addEventListener('scroll', () => window.requestAnimationFrame(bepaal), { passive: true });
      window.addEventListener('resize', bepaal, { passive: true });
      // het aantal foto's verandert bij een andere kleur
      new ResizeObserver(bepaal).observe(bak);
      new MutationObserver(bepaal).observe(bak, { childList: true, subtree: true });

      // Zolang de foto's nog laden groeit de strook, en dus klopt "past het nog"
      // pas als ze binnen zijn. Daarom nog een keer bij elke foto die aankomt en
      // een keer als de pagina helemaal klaar is.
      bak.querySelectorAll('img').forEach((afb) => {
        if (!afb.complete) afb.addEventListener('load', bepaal, { once: true });
      });
      if (document.readyState !== 'complete') {
        window.addEventListener('load', bepaal, { once: true });
      }
    }

    bepaal();
  }

  /* Drie plekken met dezelfde behoefte: een rij die breder is dan zijn kolom.
   *
   *   1. de miniaturen onder de productfoto
   *   2. de matenrij in de variantkiezer — zes passen, dertien of negentien niet
   *   3. de kleurstalen op de kaartjes in Products (hzo)
   *
   * Alle drie krijgen ze `strookRegelen`, en die zet zijn eigen merkje per
   * element, dus meerdere kaartjes op één pagina gaan vanzelf goed. */
  const STROKEN = [
    { sel: 'media-gallery .slideshow-controls__thumbnails-container', wikkel: false },
    // de twee rijen in het paneel van de meeschuivende koopbalk
    { sel: '.hzo-balk__rij--maten', paar: true },
    { sel: '.hzo-balk__rij--stalen', paar: true },
  ];

  function strokenRegelen() {
    STROKEN.forEach(({ sel, wikkel, paar }) => {
      document.querySelectorAll(sel).forEach((bak) => strookRegelen(bak, wikkel, paar));
    });
  }


  /* ─────────────── het kortingslabel bij de prijs ───────────────
   * Horizon toont de nieuwe en de oude prijs, maar rekent nergens uit hoeveel je
   * bespaart. Dat labeltje zetten we er hier bij.
   *
   * De percentages komen uit de PRIJZEN DIE ER STAAN, niet uit een aparte bron.
   * Zo kan het label nooit iets anders beweren dan de bedragen ernaast, ook niet
   * als Horizon het blok na een variantwissel opnieuw tekent.
   */

  function bedrag(tekst) {
    if (!tekst) return null;
    // laatste getal in de tekst, punt of komma als decimaalteken
    const treffers = tekst.replace(/\s/g, '').match(/[\d.,]+/g);
    if (!treffers || !treffers.length) return null;
    let ruw = treffers[treffers.length - 1];
    // 1.234,56 -> 1234.56   en   1,234.56 -> 1234.56
    if (/,\d{1,2}$/.test(ruw)) ruw = ruw.replace(/\./g, '').replace(',', '.');
    else ruw = ruw.replace(/,/g, '');
    const n = parseFloat(ruw);
    return isNaN(n) ? null : n;
  }

  function prijsRegelen(vak) {
    if (!vak) return;

    const nu = vak.querySelector('.price:not(.compare-at-price)');
    const was = vak.querySelector('.compare-at-price');
    let label = vak.querySelector('.hzo-korting');

    const a = bedrag(nu && zichtbareTekst(nu));
    const b = bedrag(was && zichtbareTekst(was));

    /* Hier stond `vak.dataset.hzoAfgeprijsd = 'false'`. Weg: de opmaak leest nu
       zelf of er een doorgestreepte oude prijs staat (`:has(.compare-at-price)`),
       en dat werkt óók in het snel-toevoegen-blad, waar dit script niet draait.
       Zolang de kleur van dit vlaggetje afhing bleef de prijs daar zwart. */
    if (!a || !b || b <= a) {
      if (label) label.remove();
      return;
    }

    const pct = Math.round((1 - a / b) * 100);
    if (pct < 1) {
      if (label) label.remove();
      return;
    }

    if (!label) {
      label = document.createElement('span');
      label.className = 'hzo-korting';
      vak.appendChild(label);
    }
    const tekst = `Save ${pct}%`;
    if (label.textContent !== tekst) label.textContent = tekst;
  }

  /* GEEN MutationObserver op het prijsvak.
   *
   * Hier stond er een, en die keek naar precies het vak waar hij zelf in schreef:
   * het label toevoegen en de tekst zetten zijn allebei wijzigingen binnen dat vak,
   * dus de waarnemer wekte zichzelf. Bij het laden viel dat niet op — pas als
   * Horizon het blok na een variantwissel opnieuw tekende sloeg het aan, en dan
   * liep het tabblad binnen een seconde vast. Gemeten op 11 aug 2026 door de
   * onderdelen één voor één uit te zetten; met het prijsdeel uit bleef de pagina leven.
   *
   * Het opnieuw zetten na een variantwissel gebeurt nu via het `change`-signaal in
   * `kijkMee`, dat een paar keer kort na elkaar `draai()` aanroept. Dat is genoeg,
   * want alleen een variantwissel laat Horizon opnieuw tekenen. */
  function prijzenRegelen() {
    document.querySelectorAll('.product-details [ref="priceContainer"]').forEach(prijsRegelen);
  }


  /* ─────────────── het maatvenster ───────────────
   * Een gewone <dialog> van de browser. `showModal()` regelt de bovenlaag, de
   * verduistering, de toetsenbordval en Escape; dat hoeven we niet na te bouwen.
   * Wat hier staat is alleen: knop opent, kruis sluit, klik naast het blad sluit.
   *
   * De knop en het venster staan bewust NIET bij elkaar in de opbouw — de knop
   * hoort in de legenda naast het woord SIZE, het venster mag daar juist niet in
   * staan omdat alles binnen dat kopje hoofdletters en letterruimte erft. Ze
   * vinden elkaar via een id.
   */

  function maatvensterRegelen() {
    document.querySelectorAll('[data-hzo-maat-open]').forEach((knop) => {
      if (knop.dataset.hzoMaatKlaar === 'true') return;
      knop.dataset.hzoMaatKlaar = 'true';
      knop.addEventListener('click', () => {
        const venster = document.getElementById(knop.dataset.hzoMaatOpen);
        if (venster && typeof venster.showModal === 'function') venster.showModal();
      });
    });

    document.querySelectorAll('.hzo-maatvenster').forEach((venster) => {
      if (venster.dataset.hzoMaatKlaar === 'true') return;
      venster.dataset.hzoMaatKlaar = 'true';

      const sluit = venster.querySelector('[data-hzo-maat-sluit]');
      if (sluit) sluit.addEventListener('click', () => venster.close());

      // naast het blad klikken sluit; de klik landt dan op het venster zelf
      venster.addEventListener('click', (e) => {
        if (e.target === venster) venster.close();
      });

      /* De pagina erachter niet mee laten schuiven.

         Let op WELK element dat is: deze winkel zet `overflow: hidden` op html en
         body en laat een binnenlaag schuiven, dus html vergrendelen doet niets.

         Eerst liep ik van het venster omhoog op zoek naar die laag. Dat gaf bij
         elke opening een ander element terug, en dan bleef er telkens één
         vergrendeld achter. Nu een vaste lijst, en bij het sluiten wordt precies
         teruggezet wat er stond — niet leeggemaakt, want dan wis je wat het thema
         er zelf op had staan. */
      let vergrendeld = [];

      const vergrendel = () => {
        ontgrendel();
        const lagen = new Set();
        const wrap = document.querySelector('.page-wrapper');
        if (wrap) lagen.add(wrap);
        if (document.scrollingElement) lagen.add(document.scrollingElement);
        lagen.forEach((el) => {
          vergrendeld.push([el, el.style.overflow]);
          el.style.overflow = 'hidden';
        });
      };

      function ontgrendel() {
        vergrendeld.forEach(([el, oud]) => {
          el.style.overflow = oud;
        });
        vergrendeld = [];
      }

      /* Niet op het `close`-signaal vertrouwen: gemeten op deze winkel gaat dat niet
         af, ook niet als het venster wel degelijk dichtgaat. In plaats daarvan
         kijken we naar het `open`-kenmerk zelf. Dat verdwijnt hoe je ook sluit —
         via het kruis, door ernaast te klikken, met Escape, of vanuit code. */
      new MutationObserver(() => {
        if (!venster.open) ontgrendel();
      }).observe(venster, { attributes: true, attributeFilter: ['open'] });

      venster.addEventListener('close', ontgrendel);

      const oorspronkelijk = venster.showModal.bind(venster);
      venster.showModal = () => {
        vergrendel();
        oorspronkelijk();
      };
    });
  }


  /* ─────────────── de prijs op de koopknop ───────────────
   * Naar de het andere thema-knop van Mason & Cole, daar opgemeten: "Add to cart >" en het
   * bedrag als twee stukken naast elkaar, allebei wit, met een ruime letterruimte
   * op het label en een krappe op de prijs.
   *
   * Het bedrag komt uit het prijsblok dat op de pagina staat, niet uit een aparte
   * bron. Zo kan de knop nooit een ander bedrag noemen dan wat erboven staat, ook
   * niet na een variantwissel.
   */

  /** De zichtbare tekst van een element: zonder wat alleen voor schermlezers is.
   *  Horizon zet in het prijsblok een verborgen "Sale price" voor voorleessoftware;
   *  die stond zo mee op de knop. */
  function zichtbareTekst(el) {
    const kopie = el.cloneNode(true);
    kopie.querySelectorAll('.visually-hidden, [class*="visually-hidden"]').forEach((v) => v.remove());
    return kopie.textContent.replace(/\s+/g, ' ').trim();
  }

  function koopknopRegelen() {
    const bron = document.querySelector(
      '.product-details [ref="priceContainer"] .price:not(.compare-at-price)'
    );
    if (!bron) return;
    const bedrag = zichtbareTekst(bron);
    if (!bedrag) return;

    document.querySelectorAll('.product-details .add-to-cart-button').forEach((knop) => {
      /* "Add to cart" staat als los tekststuk in de knop, zonder eigen element.
         Er is dus niets om het pijltje aan te hangen; daarom pakken we die tekst
         eerst in. Daarna is de vololgorde vast: label, pijltje, bedrag. */
      if (!knop.querySelector('.hzo-atc-label')) {
        const tekstknoop = Array.from(knop.childNodes).find(
          (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
        );
        if (tekstknoop) {
          const omhulsel = document.createElement('span');
          omhulsel.className = 'hzo-atc-label';
          omhulsel.textContent = tekstknoop.textContent.trim();
          tekstknoop.replaceWith(omhulsel);
        }
      }

      let prijs = knop.querySelector('.hzo-atc-prijs');
      if (!prijs) {
        prijs = document.createElement('span');
        prijs.className = 'hzo-atc-prijs';
        prijs.setAttribute('aria-hidden', 'true');
        knop.appendChild(prijs);
      }
      if (prijs.textContent !== bedrag) prijs.textContent = bedrag;

      // de prijs hoort altijd achteraan, ook nadat Horizon de knop opnieuw tekent
      if (knop.lastElementChild !== prijs) knop.appendChild(prijs);
    });
  }


  /* ─────────────── een rij die standaard openstaat ───────────────
   * Staat een uitklapper al open bij het laden, dan is het geen uitklapper meer
   * maar gewoon tekst. Dan hoort er ook geen kopregel met pijltje boven, en geen
   * scheidingslijn.
   *
   * "Standaard open" is niet hetzelfde als "nu open": dat laatste geldt ook voor
   * een rij die de bezoeker zelf heeft aangeklikt. Daarom kijken we ÉÉN keer, bij
   * het laden, en zetten we een merkje. Wat de bezoeker daarna doet verandert daar
   * niets meer aan.
   */

  function altijdOpenMerken() {
    document.querySelectorAll('.product-details details').forEach((rij) => {
      if (rij.dataset.hzoGekeurd === 'true') return;
      rij.dataset.hzoGekeurd = 'true';
      if (!rij.open) return;

      rij.dataset.hzoAltijdOpen = 'true';
      // zonder kopregel valt er niets meer te klikken; mocht iets het toch sluiten,
      // dan zetten we het terug — anders is de tekst onbereikbaar
      new MutationObserver(() => {
        if (!rij.open) rij.open = true;
      }).observe(rij, { attributes: true, attributeFilter: ['open'] });
    });
  }

  /* ─────────────── de galerij springt naar de foto van de variant ───────────
   *
   * Dit is de laatste stap van drie, en de vorige twee moesten eerst:
   *   1. `hide_variants` uit, anders zitten de foto's van de andere kleuren niet
   *      eens in de galerij;
   *   2. onze eigen galerij (blocks/hzo-media.liquid), anders sorteert Horizon de
   *      foto's om én vervangt hij de hele galerij bij elke variantklik.
   *
   * Nu de galerij blijft staan, is dit klein: zoek de dia die bij de gekozen
   * kleur hoort en laat de slideshow ernaartoe gaan.
   *
   * WE GEBRUIKEN HORIZONS EIGEN `select()`. Een eerdere poging met een eigen veer
   * schreef elk beeldje `scrollLeft` terwijl Horizons slideshow op `scroll`
   * luistert, en dat liet de pagina vastlopen. De methode van het thema zelf doet
   * de overgang al soepel en kan niet met zichzelf in de knoop raken.
   */

  /* ALLES HIERONDER GELDT ALLEEN OP HET BUREAUBLAD.
     Op 14 aug bleek de galerij op de telefoon van mijn ingrepen juist slechter te
     worden ("alles, het is enorm buggy"), terwijl desktop goed werd. Ik kan onder
     1280px niet renderen, dus elke mobiele wijziging van mij is blind. Tot dit op
     een echt toestel is nagelopen krijgt de telefoon Horizons eigen gedrag terug.
     Bij het draaien van een toestel wordt dit opnieuw gelezen, want we vragen het
     op het moment zelf en niet één keer bij het laden. */
  const BUREAU = window.matchMedia('(min-width: 750px)');

  /* wie in zijn systeem minder beweging heeft staan, krijgt de sprong zonder glijden */
  const RUSTIG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function fotoKern(url) {
    try {
      const schoon = String(url).replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
      const bestand = new URL(schoon, location.origin).pathname.split('/').pop();
      return bestand.split('.')[0].split('_')[0];
    } catch (e) {
      return '';
    }
  }

  /* ── glijden zonder dat het snappen ertussen komt ──────────────────────────
   * De eigenaar: *"van 5 naar 3 is nog instant in plaats van motion"*, terwijl
   * 5-4 en 4-3 wél soepel gaan.
   *
   * Gemeten: onze eigen `scrollTo` vuurt netjes met `behavior: smooth`, en
   * Horizons verplaats-truc draait niet meer (de volgorde verandert geen moment).
   * Wat overblijft is `scroll-snap-type: x mandatory` op de strook. Bij een
   * sprong over MEERDERE snap-punten klapt de browser meteen naar het doel in
   * plaats van eroverheen te animeren; over één snap-punt animeert hij wel. Dat
   * is precies het verschil tussen 5-4 (goed) en 5-3 (instant).
   *
   * Dus: snappen even uit tijdens de beweging, en terugzetten zodra hij er is.
   * `scrollend` is het nette signaal; de timer erachter is het vangnet voor
   * browsers die dat event niet kennen. */
  function glijNaar(strook, links, zacht) {
    if (!zacht) {
      strook.scrollTo({ left: links, behavior: 'auto' });
      return;
    }
    const snapWas = strook.style.scrollSnapType;
    let hersteld = false;
    const herstel = () => {
      if (hersteld) return;
      hersteld = true;
      strook.style.scrollSnapType = snapWas;
    };
    strook.style.scrollSnapType = 'none';
    strook.addEventListener('scrollend', herstel, { once: true });
    setTimeout(herstel, 900);
    strook.scrollTo({ left: links, behavior: 'smooth' });
  }

  function naarVariantFoto() {
    /* Dit MOET ook op de telefoon werken. Onze galerij wordt niet meer vervangen,
       dus als hier niets gebeurt, blijft de hoofdfoto bij een kleurwissel gewoon
       staan — en dat zou erger zijn dan waar we vandaan kwamen. Op de telefoon
       springt hij daarom direct, zonder de soepele scroll die daar juist voor
       problemen zorgde. */
    const galerij = document.querySelector('hzo-media-galerij, media-gallery');
    if (!galerij) return;
    const slideshow = galerij.querySelector('slideshow-component');
    if (!slideshow || typeof slideshow.select !== 'function') return;

    const aan = document.querySelector('.product-details .variant-option--swatches input:checked');
    if (!aan) return;
    const label = aan.closest('label');
    const vlak = label && label.querySelector('[class*="staal"], img');
    if (!vlak) return;
    const zoek = fotoKern(vlak.tagName === 'IMG' ? vlak.currentSrc || vlak.src : getComputedStyle(vlak).backgroundImage);
    if (!zoek) return;

    const dias = [...galerij.querySelectorAll('slideshow-slide')];
    const index = dias.findIndex((s) => {
      const im = s.querySelector('img');
      return im && fotoKern(im.currentSrc || im.src) === zoek;
    });
    if (index < 0) return;

    /* NIET `slideshow.select()`, en daar is een gemeten reden voor.
     *
     * De eigenaar: *"als ik een variant kies die niet twee plekken ernaast zit,
     * veegt hij niet meer maar flikkert hij, en dat geldt alleen terug, niet
     * heen."* Dat is precies wat Horizon doet. In slideshow.js:
     *
     *   // If jump is more than 1 or we looped, do the placeholder + reorder trick
     *   if (requestedIndex < current) currentSlide.before(targetSlide);
     *   else currentSlide.after(targetSlide);
     *
     * Bij een sprong van meer dan één dia haalt hij de doeldia uit de rij en zet
     * hem naast de huidige, zodat hij maar één diabreedte hoeft te scrollen. Zet
     * hij die ERVOOR — dus bij teruggaan — dan verspringt de scrollpositie op
     * hetzelfde moment. Dat is het geflikker, en dat is waarom het alleen
     * achteruit gebeurt.
     *
     * Wij willen juist wat het vorige thema doet: gewoon naar die foto toe glijden, hoe
     * ver hij ook weg is. Dus scrollen we zelf, met de soepele scroll van de
     * browser — één opdracht, geen eigen animatielus (die liet de pagina eerder
     * vastlopen) en geen verplaatste dia's. */
    const strook = galerij.querySelector('slideshow-slides');
    const doel = dias[index];
    if (!strook || !doel) return;

    /* eerst de foto klaarzetten, anders glijd je naar een leeg vak */
    burenKlaarzetten(index);

    glijNaar(strook, doel.offsetLeft - strook.offsetLeft, BUREAU.matches && !RUSTIG.matches);
  }

  /* ── de foto's staan klaar voordat je er bent ─────────────────────────────
   * De eigenaar: *"bij het swipen worden afbeeldingen soms niet ingeladen"*.
   * Gemeten: alle veertien dia's laadden `eager`, dus ze vochten om dezelfde
   * verbinding. In de galerij staan nu de eerste drie op `eager` en de rest op
   * `lazy` — en hier halen we telkens de buren van de dia waar je bent alvast op.
   * Zo blijft snel doorvegen gedekt zonder dat de pagina begint met veertien
   * gelijktijdige downloads.
   *
   * `decoding = 'async'` erbij: het uitpakken van een grote foto op de hoofddraad
   * geeft anders een schokje midden in een veeg. Dat is een attribuut op de
   * afbeelding, dus het kan niet met CSS.
   */
  function burenKlaarzetten(index) {
    const dias = [...document.querySelectorAll('hzo-media-galerij slideshow-slide')];
    if (!dias.length) return;
    [index - 1, index, index + 1, index + 2].forEach((i) => {
      const dia = dias[i];
      if (!dia) return;
      dia.querySelectorAll('img[loading="lazy"]').forEach((im) => {
        im.loading = 'eager';
      });
    });
  }

  function fotosVoorbereiden() {
    if (document.documentElement.dataset.hzoFotos === 'true') return;
    document.documentElement.dataset.hzoFotos = 'true';
    document.querySelectorAll('hzo-media-galerij .product-media__image').forEach((im) => {
      im.decoding = 'async';
    });
    burenKlaarzetten(0);
    document.addEventListener('slideshow:select', (e) => {
      const i = e && e.detail && typeof e.detail.index === 'number' ? e.detail.index : null;
      if (i !== null) burenKlaarzetten(i);
    });
  }

  /* ─────────────── de miniaturen glijden ook ────────────────────────────────
   *
   * De eigenaar: *"van afbeelding 5 naar 3 is instant zonder motion; 5-4, 4-3,
   * 3-2 gaan allemaal goed. Dit is alleen als je de slideshow zelf klikt."*
   *
   * Dat is Horizons `select()`, en het staat er letterlijk:
   *
   *   const isAdjacentSlide = Math.abs(index - current) <= 1 && ...
   *   if (!instant && !isAdjacentSlide && visibleSlides.length === 1) {
   *     // If jump is more than 1 or we looped, do the placeholder + reorder trick
   *
   * Naast elkaar: gewoon scrollen, dus soepel. Verder weg: de doeldia wordt uit
   * de rij gehaald en naast de huidige gezet, waarna er één diabreedte gescrold
   * wordt. Het resultaat is een sprong zonder beweging.
   *
   * We vangen de klik op een miniatuur (of een bolletje) af vóór Horizon hem
   * ziet, en glijden er zelf naartoe — dezelfde manier als bij de variantwissel.
   * Alleen binnen ONZE galerij; Horizons andere slideshows blijven zoals ze zijn.
   */
  function naarDia(index) {
    if (!BUREAU.matches) return false;
    const galerij = document.querySelector('hzo-media-galerij');
    if (!galerij) return false;
    const strook = galerij.querySelector('slideshow-slides');
    const dias = [...galerij.querySelectorAll('slideshow-slide')];
    const doel = dias[index];
    if (!strook || !doel) return false;
    burenKlaarzetten(index);
    glijNaar(strook, doel.offsetLeft - strook.offsetLeft, !RUSTIG.matches);
    return true;
  }

  function miniaturenVolgen() {
    if (document.documentElement.dataset.hzoMini === 'true') return;
    document.documentElement.dataset.hzoMini = 'true';
    document.addEventListener(
      'click',
      (e) => {
        const knop = e.target.closest && e.target.closest('[on\\:click^="/select/"]');
        if (!knop || !knop.closest('hzo-media-galerij')) return;
        const m = (knop.getAttribute('on:click') || '').match(/\/select\/(\d+)/);
        if (!m) return;
        const index = Number(m[1]);
        /* alleen overnemen als wij het echt kunnen; anders laten we Horizon gaan */
        if (naarDia(index)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function galerijVolgen() {
    if (document.documentElement.dataset.hzoGalerijVolgt === 'true') return;
    document.documentElement.dataset.hzoGalerijVolgt = 'true';

    /* NIET OP EEN TIMER. Eerst stond hier `setTimeout(..., 0)` na een `change`,
       en dat was te vroeg: de eigenaar zag bij Beige soms nog de zwarte foto.
       Horizon werkt de variant asynchroon bij en zet de galerij daarna nog aan;
       wie eerder springt wordt overschreven.

       Het thema geeft zelf het juiste moment af: `shopify:product:select` draagt
       een `promise` die klaar is als de wissel rond is. Dezelfde haak die
       Horizons eigen media-gallery gebruikt. We springen twee keer — meteen, en
       nog eens als die belofte klaar is. Twee keer hetzelfde vragen kost niets,
       want `select()` op de dia waar je al staat doet niets. */
    document.addEventListener('shopify:product:select', (e) => {
      if (e.target && e.target.closest && e.target.closest('product-card')) return;
      naarVariantFoto();
      const belofte = e.promise;
      if (belofte && typeof belofte.then === 'function') {
        belofte.then(naarVariantFoto).catch(() => {});
      }
    });
  }

  /* ─────────────── aanzetten en aan blijven staan ─────────────── */

  function draai() {
    altijdOpenMerken();
    maatvensterRegelen();
    prijzenRegelen();
    koopknopRegelen();
    voorraadRegelen();
    // eerst de balk opbouwen, dan pas de stroken zoeken: de rijen in het paneel
    // bestaan pas nadat `balkVerbouwen` ze heeft neergezet
    document.querySelectorAll('sticky-add-to-cart').forEach((b) => {
      balkVerbouwen(b);
      balkZelfTonen(b);
    });
    strokenRegelen();
  }

  let wachtLopers = [];

  /**
   * Horizon haalt na elke variantwissel een verse balk op en vervangt de inhoud.
   * Onze knoppen zijn dan weg. Eén keer terugzetten op het eerstvolgende frame is
   * te vroeg: het vervangen is dan nog bezig en wordt daarna alsnog overschreven.
   * Daarom kijken we een paar keer kort na elkaar; `maakBalkKiezers` doet niets
   * als de rij er al staat, dus vaker proberen kost niets.
   */
  function opnieuwZetten() {
    wachtLopers.forEach(clearTimeout);
    wachtLopers = [60, 200, 500, 900].map((ms) => setTimeout(draai, ms));
  }

  /* Horizon tekent de prijs en de koopknop opnieuw zodra je een variant kiest.
   * Onze toevoegingen (het kortingslabel, de prijs op de knop) zijn dan weg.
   *
   * GEEN MutationObserver op de productkolom: onze eigen toevoegingen zijn zelf
   * ook wijzigingen in die kolom, dus die zou zichzelf blijven aanroepen. We
   * luisteren daarom naar het enige moment waarop Horizon opnieuw tekent: een
   * andere radioknop in de variantkiezer. */
  function kijkMee() {
    if (document.documentElement.dataset.hzoKijktMee === 'true') return;
    document.documentElement.dataset.hzoKijktMee = 'true';
    document.addEventListener('change', (e) => {
      const doel = e.target;
      if (doel && doel.closest && doel.closest('.product-details variant-picker, variant-picker')) {
        opnieuwZetten();
      }
    });
  }

  /* ─────────────── de gekozen kleur staat er METEEN ───────────────
   *
   * DE KLACHT (16 aug 2026): *"als ik een kleur selecteer is de tekst ernaast vd
   * kleur die springt sloom over — dat moet echt snel en niet laggy"*.
   *
   * DE OORZAAK, gemeten op de live winkel met een waarnemer op het kleurveld
   * (geen timers, dus geen giswerk). Twaalf metingen: 2 motoren x 2 breedtes x
   * 3 kleurwissels.
   *
   *     het rondje wordt aangevinkt   2 - 6 ms
   *     de naam ernaast verandert     262 - 924 ms
   *
   * Horizon rendert die naam namelijk aan de serverkant: bij elke variantwissel
   * haalt `variant-picker.js` de hele kiezer opnieuw op en zet die met `morph`
   * in de plaats. De stalen reageren direct omdat dat gewoon CSS op `:checked`
   * is, maar de tekst wacht op de netwerkronde. Dat is precies het naspringen
   * dat de eigenaar ziet — geen animatie, geen overgang, maar wachttijd.
   *
   * DE REPARATIE. We schrijven de naam zelf, in dezelfde tik als de klik. De
   * waarde staat al in de radioknop (`value`), dus er hoeft niets opgehaald te
   * worden. De latere morph zet exact dezelfde tekst terug, dus er knippert
   * niets en er ontstaat geen tweede bron van waarheid: de server blijft de
   * baas, wij lopen alleen even vooruit.
   *
   * `capture: true` zodat dit gebeurt vóór Horizons eigen luisteraar aan zijn
   * fetch begint, en niet erachteraan in de wachtrij komt.
   *
   * Op documentniveau en niet per veld: dan geldt het ook voor de kiezer in het
   * snel-toevoegen-venster, dat pas later in de pagina komt.
   */
  document.addEventListener(
    'change',
    (e) => {
      const invoer = e.target;
      if (!invoer || invoer.type !== 'radio') return;
      const veld = invoer.closest('.variant-option');
      if (!veld) return;
      const plek = veld.querySelector('.variant-option__swatch-value');
      if (!plek) return;
      const naam = (invoer.value || '').trim();
      /* het streepje ervoor komt uit de opmaak (::before), dus alleen de naam */
      if (naam && plek.textContent.trim() !== naam) plek.textContent = naam;
    },
    true
  );

  /* ─────────────── de voorraadregel springt meteen mee ───────────────
   *
   * DEZELFDE OORZAAK als bij de kleurnaam hierboven. `voorraadRegelen()` leest
   * welke variant gekozen is uit het verborgen veld `name="id"`, en dat veld
   * schrijft Horizon pas als zijn hertekening over het netwerk terug is. Daar
   * bovenop stond de functie in `draai()`, die na een wissel op vaste momenten
   * loopt (60/200/500/900 ms) — dus zelfs als het veld al klaar was, kon het
   * getal nog tot 900 ms blijven staan.
   *
   * Het getal hoeft niet opgehaald te worden: de hele tabel variant -> getal
   * staat al in `data-hzo-voorraadkaart`, en welk variantnummer erbij hoort
   * staat in de aangeklikte radioknop zelf (`data-variant-id`). Alles is dus al
   * op de pagina aanwezig op het moment van de klik.
   *
   * We wachten daarom niet: we zetten de variant in `vroegeVariant` en tekenen
   * de regel meteen. Zodra Horizon het verborgen veld bijtrekt, wist
   * `voorraadRegelen()` die variabele zelf en is de server weer de baas.
   */
  document.addEventListener(
    'change',
    (e) => {
      const invoer = e.target;
      if (!invoer || invoer.type !== 'radio') return;
      if (!invoer.closest('.variant-option')) return;
      const id = invoer.dataset.variantId;
      if (!id) return;
      vroegeVariant = id;
      voorraadRegelen();
    },
    true
  );

  /* ─────────────── de knop mag geen moment kaal staan ───────────────
   *
   * DE KLACHT. De eigenaar: *"eerst de normale cart met > prijs en dan als ik van
   * variant switch zie ik alleen ADD TO CART, en die save-knop verschijnt en
   * verdwijnt heen en weer"*. Twee verschijningsvormen van dezelfde knop, vlak na
   * elkaar.
   *
   * GEMETEN met een waarnemer op de knoptekst (geen timers, dus betrouwbaar):
   *   "ADD TO CART $65.95"  ->  "ADD TO CART"  ->  "ADD TO CART $65.95"
   *
   * DE OORZAAK. Horizon haalt na een variantwissel een verse knop op en zet die
   * in de plaats. Alles wat wij eraan hangen — het bedrag, het pijltje, het
   * kortingslabel — is dan weg. `opnieuwZetten()` herstelt dat, maar op VASTE
   * MOMENTEN (60/200/500/900 ms). De hertekening komt over het netwerk en landt
   * dus meestal ná 60 ms; tussen die twee zit een gat waarin de knop kaal staat.
   * Dat gat is wat je ziet.
   *
   * WAAROM HIER EERST GEEN WAARNEMER STOND, en waarom dat nu wel kan. De reden was
   * terecht: onze eigen toevoegingen zijn zelf ook wijzigingen in die kolom, dus
   * een waarnemer zou zichzelf blijven aanroepen. Twee sloten daartegen, hetzelfde
   * patroon als in hzo-lade.js:
   *   - we doen alleen iets als er ECHT iets ontbreekt; is de knop compleet, dan
   *     keren we meteen terug en gebeurt er niets;
   *   - tijdens ons eigen schrijven staat de waarnemer los.
   *
   * De ladder blijft staan als vangnet: die vangt het geval waarin alleen het
   * BEDRAG verandert terwijl onze elementen blijven staan.
   */
  let knopWaarnemer = null;

  function ietsOntbreekt() {
    const knoppen = [...document.querySelectorAll('.product-details .add-to-cart-button')];
    if (knoppen.length && knoppen.some((k) => !k.querySelector('.hzo-atc-prijs') || !k.querySelector('.hzo-atc-label'))) {
      return true;
    }
    /* DE MEESCHUIVENDE BALK, om dezelfde reden.
       De eigenaar: *"op mobiel hapert de sticky add to cart, hij verdwijnt en
       komt pas heel laat weer terug"*. Horizon haalt na een variantwissel een
       verse balk op; onze knopjesrij is dan weg en `opnieuwZetten()` zet hem pas
       op 60/200/500/900 ms terug. Dat gat is wat je ziet — precies hetzelfde
       verhaal als bij de koopknop, en dus dezelfde oplossing: herstellen op de
       gebeurtenis in plaats van op de klok.

       `eigenRijen` is hier de maatstaf en niet "staat er een rij?": Horizon
       kopieert bij het hertekenen de OPMAAK van onze knopjes mee, maar niet de
       klikafhandeling. Je houdt dan een rij over die er goed uitziet en niets
       doet. */
    const balken = [...document.querySelectorAll('sticky-add-to-cart')];
    return balken.some((b) => {
      const bar = b.querySelector('[ref="stickyBar"]');
      if (!bar) return false;
      const rij = bar.querySelector('.hzo-balk__kiezers');
      return !rij || !eigenRijen.has(rij);
    });
  }

  function knopBewaken() {
    const kolom = document.querySelector('.product-details');
    if (!kolom || knopWaarnemer) return;
    /* De balk staat BUITEN `.product-details`, dus kijken we naar de sectie
       eromheen — daar zitten ze allebei in. Valt die niet te vinden, dan blijft
       het bij de kolom en werkt in elk geval de knop nog. */
    const blok = kolom.closest('[id^="shopify-section-"]') || kolom;
    knopWaarnemer = new MutationObserver(() => {
      if (!ietsOntbreekt()) return;
      knopWaarnemer.disconnect();
      koopknopRegelen();
      prijzenRegelen();
      document.querySelectorAll('sticky-add-to-cart').forEach((b) => {
        balkVerbouwen(b);
        balkZelfTonen(b);
      });
      knopWaarnemer.observe(blok, { childList: true, subtree: true });
    });
    knopWaarnemer.observe(blok, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      draai();
      kijkMee();
      knopBewaken();
      galerijVolgen();
    fotosVoorbereiden();
    miniaturenVolgen();
      fotosVoorbereiden();
    miniaturenVolgen();
      miniaturenVolgen();
    });
  } else {
    draai();
    kijkMee();
    knopBewaken();
    galerijVolgen();
    fotosVoorbereiden();
    miniaturenVolgen();
  }

  // in de thema-editor wordt een sectie opnieuw getekend zonder paginawissel
  document.addEventListener('shopify:section:load', () => {
    draai();
    kijkMee();
    /* de sectie is vervangen, dus de oude waarnemer kijkt naar een element dat
       niet meer in de pagina staat */
    if (knopWaarnemer) { knopWaarnemer.disconnect(); knopWaarnemer = null; }
    knopBewaken();
  });
  document.addEventListener('shopify:block:select', draai);
})();
